import React, { useEffect, useState } from "react";
import ResponsiveModalAbsolute from "../../../components/ResponsiveModalAbsolute";
import Swal from "sweetalert2";
import { useAppSelector } from "../../../hooks/hooks";
import { fetchAxiosToken } from "../../../helpers/fetchAxiosToken";
import { plantillas } from "./ChatRoom";
import { motion } from "framer-motion";
import { ar } from "date-fns/locale";

interface Props {
    modalPlantilla: boolean;
    setModalPlantilla: React.Dispatch<React.SetStateAction<boolean>>;
    setPlantillas: React.Dispatch<React.SetStateAction<plantillas[]>>;
    id_plantilla: number;
}

interface plantilla {
    mensaje: string;
    titulo: string;
    imagenes: imagen[];
    archivos: archivo[];
    tipo: string;
}

interface imagen {
    id: string;
    imagen: string;
    caption: string;
    orden: number;
}

interface archivo {
    id: string;
    archivo: string;
    caption: string;
    orden: number;
}

interface imagenes {
    imagen: File;
    caption_imagen: string;
}

interface archivos {
    archivo: File;
    caption_archivo: string;
}

const ModalPlantillaEdit = ({
    modalPlantilla,
    setModalPlantilla,
    setPlantillas,
    id_plantilla,
}: Props) => {
    const casa = useAppSelector((state) => state.landing_house.house);
    const { id, tipo_usuario } = useAppSelector(
        (state) => state.usuario_logeado
    );

    const [tab, setTab] = useState<string>("mensaje");
    const [previewImages, setPreviewImages] = useState<string[]>([]);
    const [imagenes, setImagenes] = useState<imagenes[]>([]);
    const [archivos, setArchivos] = useState<archivos[]>([]);
    const [errorArchivo, setErrorArchivo] = useState<string | null>(null);
    const [errorImagen, setErrorImagen] = useState<string | null>(null);

    const [imagenSaveSeleccionada, setImagenSaveSeleccionada] =
        useState<imagen | null>(null);

    const [imagenSeleccionada, setImagenSeleccionada] = useState<number | null>(
        null
    );

    const [archivoSeleccionado, setArchivoSeleccionado] = useState<
        number | null
    >(null);

    const [archivoSaveSeleccionado, setArchivoSaveSeleccionado] =
        useState<archivo | null>(null);

    const [orden, setOrden] = useState(0);

    const [plantilla, setPlantilla] = useState<plantilla>({
        mensaje: "",
        titulo: "",
        imagenes: [],
        archivos: [],
        tipo: "",
    });

    useEffect(() => {
        getPlantilla();
        setImagenes([]);
        setArchivos([]);
        setPreviewImages([]);
        setImagenSeleccionada(null);
        setArchivoSeleccionado(null);
    }, [modalPlantilla]);

    const getPlantilla = async () => {
        const response = await fetchAxiosToken({
            url: `/plantillas_whatsapp/getOne/${id_plantilla}`,
        });

        setPlantilla({
            mensaje: response.mensaje,
            titulo: response.titulo,
            imagenes: response.imagenes,
            archivos: response.archivos,
            tipo: response.tipo,
        });

        setTab(response.tipo);

        if (response.tipo === "imagen" && Array.isArray(response.imagenes)) {
            const maxOrden = response.imagenes.length
                ? Math.max(
                      ...response.imagenes.map((img: imagen) => img.orden || 0)
                  )
                : 0;
            setOrden(maxOrden);
        } else if (
            response.tipo === "archivo" &&
            Array.isArray(response.archivos)
        ) {
            const maxOrden = response.archivos.length
                ? Math.max(
                      ...response.archivos.map(
                          (file: archivo) => file.orden || 0
                      )
                  )
                : 0;
            setOrden(maxOrden);
        }
    };

    const guardarPlantilla = async () => {
        if (!plantilla.titulo.trim()) {
            Swal.fire({
                icon: "warning",
                title: "Campo requerido",
                text: "El título no puede estar vacío.",
            });
            return;
        }

        if (tab === "mensaje" && !plantilla.mensaje.trim()) {
            Swal.fire({
                icon: "warning",
                title: "Campo requerido",
                text: "El mensaje no puede estar vacío.",
            });
            return;
        }

        if (tab === "imagen") {
            // Validar si existe un error en la imagen
            if (errorImagen) {
                Swal.fire({
                    icon: "error",
                    title: "Imagen inválida",
                    text: errorImagen,
                });
                return;
            }

            // Validar si hay imagen cargada
        }

        if (tab === "archivo") {
            if (errorArchivo) {
                Swal.fire({
                    icon: "error",
                    title: "Archivo inválido",
                    text: errorArchivo,
                });
                return;
            }
        }

        let id_casa = 0;
        let id_corredor = 0;

        if (tipo_usuario === 6) {
            id_corredor = id;
        }

        if (tipo_usuario === 3 || tipo_usuario === 8) {
            id_casa = casa.id;
        }

        try {
            // aquí tu llamada fetch/axios, por ejemplo:
            const response = await fetchAxiosToken({
                url: `/plantillas_whatsapp/put/${id_plantilla}`,
                method: "put",
                body: {
                    mensaje: plantilla.mensaje,
                    titulo: plantilla.titulo,
                },
            });

            const formData = new FormData();
            formData.append("id", id_plantilla.toString());
            formData.append("orden", orden.toString());

            if (tab === "imagen" && imagenes.length > 0) {
                imagenes.forEach((img, index) => {
                    console.log(img);
                    formData.append("imagen_whatsapp", img.imagen); // Importante: usa [] si el backend lo espera como array
                    formData.append("caption_imagen", img.caption_imagen); // Importante: usa [] si el backend lo espera como array
                });

                await fetchAxiosToken({
                    url: `/plantillas_whatsapp/postImagenes`,
                    method: "post",
                    body: formData,
                });
            }
            if (tab === "archivo" && archivos.length > 0) {
                archivos.forEach((file) => {
                    formData.append("archivo_whatsapp", file.archivo); // Usa [] si el backend espera array
                    formData.append("caption_archivo", file.caption_archivo); // Usa [] si el backend espera array
                });

                await fetchAxiosToken({
                    url: `/plantillas_whatsapp/postArchivos`,
                    method: "post",
                    body: formData,
                });
            }

            Swal.fire({
                icon: "success",
                title: "Plantilla guardada",
                timer: 1500,
                showConfirmButton: false,
            });

            // Puedes cerrar el modal aquí si quieres:
            setModalPlantilla(false);
            getPlantillas();
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "No se pudo guardar la plantilla.",
            });
        }
    };

    const getPlantillas = async () => {
        let id_casa = 0;
        let id_corredor = 0;

        if (tipo_usuario === 6) {
            id_corredor = id;
        }

        if (tipo_usuario === 3 || tipo_usuario === 8) {
            id_casa = casa.id;
        }

        const response = await fetchAxiosToken({
            url: `/plantillas_whatsapp/getAll/1/${id_casa}/${id_corredor}/?query=`,
        });

        setPlantillas(response.rows);
    };

    const handleRemoveImage = (id: number) => {
        setPreviewImages((prev) => prev.filter((_, i) => i !== id));
        setImagenes((prev) => prev.filter((_, i) => i !== id));
    };

    const handleRemoveArchivo = (id: number) => {
        setArchivos((prev) => prev.filter((_, i) => i !== id));
    };

    const handleDeleteImage = async (id: string) => {
        await fetchAxiosToken({
            url: `/plantillas_whatsapp/deleteImage/${id}`,
            method: "delete",
        });
        setPlantilla((prev) => ({
            ...prev,
            imagenes: prev.imagenes?.filter((img) => img.id !== id) || [],
        }));
    };

    const handleDeleteArchivo = async (id: string) => {
        await fetchAxiosToken({
            url: `/plantillas_whatsapp/deleteArchivo/${id}`,
            method: "delete",
        });
        setPlantilla((prev) => ({
            ...prev,
            archivos: prev.archivos.filter((a: any) => a.id !== id) || [],
        }));
    };

    const handleSaveImage = async (imagen: imagen) => {
        await fetchAxiosToken({
            url: `/plantillas_whatsapp/putImagen`,
            method: "put",
            body: {
                id: imagen.id,
                caption: imagen.caption,
            },
        });
        setImagenSaveSeleccionada(null);
        getPlantilla();
    };

    const handleSaveArchivo = async (archivo: archivo) => {
        await fetchAxiosToken({
            url: `/plantillas_whatsapp/putArchivo`,
            method: "put",
            body: {
                id: archivo.id,
                caption: archivo.caption,
            },
        });
        setArchivoSaveSeleccionado(null);
        getPlantilla();
    };

    return (
        <div>
            <ResponsiveModalAbsolute
                modalVisible={modalPlantilla}
                setModalVisible={setModalPlantilla}
            >
                <div className="flex flex-col justify-center items-center">
                    <div className="text-2xl text-center font-bold">
                        Mensaje de plantilla
                    </div>
                    <hr className=" border-2 my-2 w-5/6 mx-auto" />
                    {imagenSeleccionada === null &&
                        archivoSeleccionado === null &&
                        imagenSaveSeleccionada === null &&
                        archivoSaveSeleccionado === null && (
                            <div className="w-5/6">
                                <div className="flex flex-col justify-start items-start w-full  mt-10 gap-3">
                                    <div className="font-semibold text-xl w-5/6 mx-auto">
                                        Titulo:
                                    </div>
                                    <div className=" text-base w-5/6 mx-auto">
                                        <input
                                            type="text"
                                            value={plantilla.titulo}
                                            className="p-2 rounded-lg  border-2 w-full"
                                            onChange={(e) =>
                                                setPlantilla({
                                                    ...plantilla,
                                                    titulo: e.target.value,
                                                })
                                            }
                                        />
                                    </div>
                                </div>

                                {tab === "mensaje" && (
                                    <>
                                        <div className="flex flex-col justify-start items-start w-full mt-10 gap-3">
                                            <div className="font-semibold text-xl w-5/6 mx-auto">
                                                Mensaje:
                                            </div>

                                            <div className="text-base w-5/6 mx-auto ">
                                                <textarea
                                                    value={plantilla.mensaje}
                                                    onChange={(e) => {
                                                        if (
                                                            e.target.value
                                                                .length <= 500
                                                        ) {
                                                            setPlantilla({
                                                                ...plantilla,
                                                                mensaje:
                                                                    e.target
                                                                        .value,
                                                            });
                                                        }
                                                    }}
                                                    className="p-2 rounded-lg border  w-full resize-none"
                                                    rows={5}
                                                    placeholder="Escribe tu mensaje..."
                                                />
                                                <div className="text-sm text-right text-gray-600 mt-1">
                                                    {plantilla.mensaje.length}
                                                    /500
                                                </div>
                                            </div>
                                        </div>
                                        <div className="text-sm text-gray-500 mt-2">
                                            <p className="font-semibold">
                                                Instrucciones para dar formato
                                                en WhatsApp:
                                            </p>
                                            <ul className="list-disc ml-4 mt-1">
                                                <li>
                                                    Para texto en{" "}
                                                    <strong>negrita</strong>,
                                                    use asteriscos:{" "}
                                                    <code>*Hola*</code>
                                                </li>
                                                <li>
                                                    Para texto en{" "}
                                                    <em>cursiva</em>, use
                                                    guiones bajos:{" "}
                                                    <code>_Hola_</code>
                                                </li>
                                                <li>
                                                    Para texto <s>tachado</s>,
                                                    use virgulillas:{" "}
                                                    <code>~Hola~</code>
                                                </li>
                                                <li>
                                                    Para{" "}
                                                    <code>monoespaciado</code>,
                                                    use tres acentos invertidos:{" "}
                                                    <code>```Hola```</code>
                                                </li>
                                            </ul>
                                        </div>
                                    </>
                                )}

                                {tab === "imagen" && (
                                    <div className="flex flex-col justify-start items-start w-full mt-10 gap-3">
                                        <div className="font-semibold text-xl w-5/6 mx-auto">
                                            Cargar imágenes:
                                        </div>

                                        <div className="text-base w-5/6 mx-auto ">
                                            <input
                                                type="file"
                                                accept="image/*"
                                                multiple
                                                onChange={(e) => {
                                                    const files = Array.from(
                                                        e.target.files || []
                                                    );
                                                    const validImages: imagenes[] =
                                                        [];

                                                    for (const file of files) {
                                                        if (
                                                            !file.type.startsWith(
                                                                "image/"
                                                            )
                                                        ) {
                                                            setErrorImagen(
                                                                "Todos los archivos deben ser imágenes."
                                                            );
                                                            return;
                                                        }
                                                        validImages.push({
                                                            imagen: file,
                                                            caption_imagen: "", // caption vacío por defecto
                                                        });
                                                    }

                                                    // Generar previsualizaciones
                                                    validImages.forEach(
                                                        ({ imagen }) => {
                                                            const reader =
                                                                new FileReader();
                                                            reader.onloadend =
                                                                () => {
                                                                    setPreviewImages(
                                                                        (
                                                                            prev
                                                                        ) => [
                                                                            ...prev,
                                                                            reader.result as string,
                                                                        ]
                                                                    );
                                                                };
                                                            reader.readAsDataURL(
                                                                imagen
                                                            );
                                                        }
                                                    );

                                                    setImagenes((prev) => [
                                                        ...prev,
                                                        ...validImages,
                                                    ]);
                                                    setErrorImagen(null);
                                                }}
                                                className="p-2 rounded-lg border-2 w-full bg-white cursor-pointer"
                                            />

                                            {errorImagen && (
                                                <div className="text-red-600 text-sm mt-2">
                                                    {errorImagen}
                                                </div>
                                            )}

                                            {(previewImages.length > 0 ||
                                                plantilla.imagenes?.length >
                                                    0) && (
                                                <div className="flex flex-col justify-center items-center gap-4 mt-5">
                                                    {/* Imágenes traídas del backend */}
                                                    {plantilla.imagenes?.map(
                                                        (imgObj, i) => (
                                                            <div
                                                                onClick={() =>
                                                                    setImagenSaveSeleccionada(
                                                                        imgObj
                                                                    )
                                                                }
                                                                key={`saved-${i}`}
                                                                className="relative group hover:scale-105 transition-transform shadow-lg border w-[300px] py-5 duration-200  rounded-lg cursor-pointer flex flex-col justify-center items-center "
                                                            >
                                                                <img
                                                                    src={`${process.env.REACT_APP_PROXY}/plantillas_whatsapp/getImagen/${imgObj.imagen}`}
                                                                    alt={`Imagen guardada ${i}`}
                                                                    className="max-w-[150px] max-h-[150px] rounded-lg mx-auto"
                                                                />
                                                                <div className="mt-2 text-sm text-left whitespace-pre-wrap w-5/6  mx-auto">
                                                                    {
                                                                        imgObj.caption
                                                                    }
                                                                </div>
                                                                <button
                                                                    onClick={(
                                                                        e
                                                                    ) => {
                                                                        e.stopPropagation();
                                                                        handleDeleteImage(
                                                                            imgObj.id
                                                                        );
                                                                    }}
                                                                    className="absolute top-1 right-1 p-1 bg-white border border-red-500 rounded-full shadow-md text-red-600 "
                                                                    title="Eliminar imagen"
                                                                >
                                                                    <svg
                                                                        fill="none"
                                                                        viewBox="0 0 24 24"
                                                                        strokeWidth="1.5"
                                                                        stroke="currentColor"
                                                                        className="w-6 h-6 text-red-500"
                                                                    >
                                                                        <path
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                            d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                                                                        />
                                                                    </svg>
                                                                </button>
                                                            </div>
                                                        )
                                                    )}

                                                    {/* Imágenes nuevas */}
                                                    {previewImages.map(
                                                        (img, i) => (
                                                            <div
                                                                onClick={() =>
                                                                    setImagenSeleccionada(
                                                                        i
                                                                    )
                                                                }
                                                                key={i}
                                                                className="relative group hover:scale-105 transition-transform shadow-lg border w-[300px] py-5 duration-200  rounded-lg cursor-pointer flex flex-col justify-center items-center "
                                                            >
                                                                <img
                                                                    src={img}
                                                                    alt={`Preview ${i}`}
                                                                    className="max-w-[150px] max-h-[150px] rounded-lg mx-auto"
                                                                />
                                                                <div className="mt-2 text-sm text-left whitespace-pre-wrap w-5/6  mx-auto">
                                                                    {
                                                                        imagenes[
                                                                            i
                                                                        ]
                                                                            ?.caption_imagen
                                                                    }
                                                                </div>
                                                                <button
                                                                    onClick={(
                                                                        e
                                                                    ) => {
                                                                        e.stopPropagation();
                                                                        handleRemoveImage(
                                                                            i
                                                                        );
                                                                    }}
                                                                    className="absolute top-1 right-1 bg-white border border-red-500 text-red-600 rounded-full p-1 text-xs"
                                                                    title="Eliminar imagen"
                                                                >
                                                                    <svg
                                                                        fill="none"
                                                                        viewBox="0 0 24 24"
                                                                        strokeWidth="1.5"
                                                                        stroke="currentColor"
                                                                        className="w-6 h-6 text-red-500"
                                                                    >
                                                                        <path
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                            d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                                                                        />
                                                                    </svg>
                                                                </button>
                                                            </div>
                                                        )
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}

                                {tab === "archivo" && (
                                    <div className="flex flex-col justify-start items-start w-full mt-10 gap-3">
                                        <div className="font-semibold text-xl w-5/6 mx-auto">
                                            Cargar archivo:
                                        </div>

                                        <div className="text-base w-5/6 mx-auto">
                                            <input
                                                type="file"
                                                multiple
                                                onChange={(e) => {
                                                    const files = Array.from(
                                                        e.target.files || []
                                                    );
                                                    const maxSize =
                                                        5 * 1024 * 1024; // 5MB
                                                    const validFiles: archivos[] =
                                                        [];

                                                    for (const file of files) {
                                                        if (
                                                            file.size > maxSize
                                                        ) {
                                                            setErrorArchivo(
                                                                `El archivo ${file.name} supera el límite de 5 MB.`
                                                            );
                                                            return;
                                                        }
                                                        validFiles.push({
                                                            archivo: file,
                                                            caption_archivo: "", // caption vacío por defecto
                                                        });
                                                    }

                                                    setArchivos((prev) => [
                                                        ...prev,
                                                        ...validFiles,
                                                    ]);
                                                }}
                                                className="p-2 rounded-lg border-2 w-full bg-white cursor-pointer"
                                            />

                                            {errorArchivo && (
                                                <div className="text-red-600 text-sm mt-2">
                                                    {errorArchivo}
                                                </div>
                                            )}

                                            {/* Archivo nuevo cargado */}
                                            {plantilla.archivos?.length > 0 && (
                                                <div className="mt-3 text-sm text-gray-700 w-full">
                                                    <p className="mb-1">
                                                        Archivos seleccionados:
                                                    </p>
                                                    <ul className="list-disc ml-5">
                                                        {plantilla.archivos.map(
                                                            (archivo: any) => (
                                                                <li
                                                                    onClick={() =>
                                                                        setArchivoSaveSeleccionado(
                                                                            archivo
                                                                        )
                                                                    }
                                                                    key={
                                                                        archivo.id
                                                                    }
                                                                    className="mt-2 cursor-pointer flex flex-col justify-center items-center px-2 py-3 bg-gray-100 rounded-md hover:bg-gray-200 transition-colors"
                                                                >
                                                                    <div className="flex justify-between items-center w-full">
                                                                        <a
                                                                            href={`${process.env.REACT_APP_PROXY}/plantillas_whatsapp/getArchivo/${archivo.archivo}`}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            className="text-blue-600 underline"
                                                                        >
                                                                            {
                                                                                archivo.archivo
                                                                            }
                                                                        </a>
                                                                        <button
                                                                            className=" p-1 bg-white border border-red-500 rounded-full shadow-md text-red-600 mx-3 "
                                                                            title="Eliminar archivo"
                                                                            onClick={(
                                                                                e
                                                                            ) => {
                                                                                e.stopPropagation();
                                                                                handleDeleteArchivo(
                                                                                    archivo.id
                                                                                );
                                                                            }}
                                                                        >
                                                                            <svg
                                                                                fill="none"
                                                                                viewBox="0 0 24 24"
                                                                                strokeWidth="1.5"
                                                                                stroke="currentColor"
                                                                                className="w-5 h-5 text-red-500"
                                                                            >
                                                                                <path
                                                                                    strokeLinecap="round"
                                                                                    strokeLinejoin="round"
                                                                                    d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                                                                                />
                                                                            </svg>
                                                                        </button>
                                                                    </div>
                                                                    <div className="mt-2 border-t-2 py-3  text-sm text-left whitespace-pre-wrap w-5/6  mx-auto">
                                                                        {
                                                                            archivo.caption
                                                                        }
                                                                    </div>
                                                                </li>
                                                            )
                                                        )}
                                                    </ul>
                                                </div>
                                            )}

                                            {archivos.length > 0 && (
                                                <div className="text-sm text-gray-700 w-full">
                                                    <ul className="list-disc ml-5">
                                                        {archivos.map(
                                                            (
                                                                archivo,
                                                                index
                                                            ) => (
                                                                <li
                                                                    onClick={() =>
                                                                        setArchivoSeleccionado(
                                                                            index
                                                                        )
                                                                    }
                                                                    key={index}
                                                                    className="mt-2 cursor-pointer flex flex-col justify-center items-center px-2 py-3 bg-gray-100 rounded-md hover:bg-gray-200 transition-colors"
                                                                >
                                                                    <div className="flex justify-between items-center w-full">
                                                                        <span>
                                                                            {
                                                                                archivo
                                                                                    .archivo
                                                                                    .name
                                                                            }{" "}
                                                                            (
                                                                            {(
                                                                                archivo
                                                                                    .archivo
                                                                                    .size /
                                                                                1024
                                                                            ).toFixed(
                                                                                2
                                                                            )}{" "}
                                                                            KB)
                                                                        </span>
                                                                        <button
                                                                            className=" p-1 bg-white border border-red-500 rounded-full shadow-md text-red-600 mx-3 "
                                                                            title="Eliminar archivo"
                                                                            onClick={(
                                                                                e
                                                                            ) => {
                                                                                e.stopPropagation();
                                                                                handleRemoveArchivo(
                                                                                    index
                                                                                );
                                                                            }}
                                                                        >
                                                                            <svg
                                                                                fill="none"
                                                                                viewBox="0 0 24 24"
                                                                                strokeWidth="1.5"
                                                                                stroke="currentColor"
                                                                                className="w-5 h-5 text-red-500"
                                                                            >
                                                                                <path
                                                                                    strokeLinecap="round"
                                                                                    strokeLinejoin="round"
                                                                                    d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                                                                                />
                                                                            </svg>
                                                                        </button>
                                                                    </div>
                                                                    <div className="mt-2 border-t-2 py-3  text-sm text-left whitespace-pre-wrap w-5/6  mx-auto">
                                                                        {
                                                                            archivos[
                                                                                index
                                                                            ]
                                                                                ?.caption_archivo
                                                                        }
                                                                    </div>
                                                                </li>
                                                            )
                                                        )}
                                                    </ul>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}

                                <div
                                    onClick={() => guardarPlantilla()}
                                    className="w-5/6 mx-auto bg-[#029BFC] text-white rounded-lg p-2 text-lg mt-5 text-center cursor-pointer hover:scale-105 "
                                >
                                    Guardar
                                </div>
                            </div>
                        )}

                    {imagenSeleccionada !== null && (
                        // Vista de imagen seleccionada con textarea
                        <motion.div
                            initial={{ scale: 0.5, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            exit={{ scale: 0.5, opacity: 0 }}
                            className="w-full flex flex-col items-center gap-4"
                        >
                            <img
                                src={previewImages[imagenSeleccionada]}
                                alt="Imagen seleccionada"
                                className="w-auto h-[300px] rounded-xl border"
                            />
                            <textarea
                                className="w-5/6 max-w-xl p-2 border rounded-md mt-3"
                                placeholder="Escribe una descripción..."
                                value={
                                    imagenes[imagenSeleccionada]?.caption_imagen
                                }
                                rows={5}
                                onChange={(e) => {
                                    const nuevas = [...imagenes];
                                    nuevas[imagenSeleccionada].caption_imagen =
                                        e.target.value;
                                    setImagenes(nuevas);
                                }}
                            />

                            <div className="text-sm text-gray-500 mt-2">
                                <p className="font-semibold">
                                    Instrucciones para dar formato en WhatsApp:
                                </p>
                                <ul className="list-disc ml-4 mt-1">
                                    <li>
                                        Para texto en <strong>negrita</strong>,
                                        use asteriscos: <code>*Hola*</code>
                                    </li>
                                    <li>
                                        Para texto en <em>cursiva</em>, use
                                        guiones bajos: <code>_Hola_</code>
                                    </li>
                                    <li>
                                        Para texto <s>tachado</s>, use
                                        virgulillas: <code>~Hola~</code>
                                    </li>
                                    <li>
                                        Para <code>monoespaciado</code>, use
                                        tres acentos invertidos:{" "}
                                        <code>```Hola```</code>
                                    </li>
                                </ul>
                            </div>
                            <button
                                onClick={() => setImagenSeleccionada(null)}
                                className="mt-4 bg-blue-500 text-white px-4 py-2 rounded hover:scale-105"
                            >
                                Guardar
                            </button>
                        </motion.div>
                    )}

                    {archivoSeleccionado !== null && (
                        // Vista de imagen seleccionada con textarea
                        <motion.div
                            initial={{ scale: 0.5, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            exit={{ scale: 0.5, opacity: 0 }}
                            className="w-full flex flex-col items-center gap-4 mt-5"
                        >
                            <div className="text-lg px-2 py-1 bg-gray-200 rounded-md">
                                <strong>Nombre:</strong>{" "}
                                {archivos[archivoSeleccionado]?.archivo.name} —{" "}
                                {(
                                    archivos[archivoSeleccionado]?.archivo
                                        .size / 1024
                                ).toFixed(2)}{" "}
                                KB
                            </div>
                            <textarea
                                className="w-5/6 max-w-xl p-2 border rounded-md mt-3"
                                placeholder="Escribe una descripción..."
                                value={
                                    archivos[archivoSeleccionado]
                                        ?.caption_archivo
                                }
                                rows={5}
                                onChange={(e) => {
                                    const nuevas = [...archivos];
                                    nuevas[
                                        archivoSeleccionado
                                    ].caption_archivo = e.target.value;
                                    setArchivos(nuevas);
                                }}
                            />

                            <div className="text-sm text-gray-500 mt-2">
                                <p className="font-semibold">
                                    Instrucciones para dar formato en WhatsApp:
                                </p>
                                <ul className="list-disc ml-4 mt-1">
                                    <li>
                                        Para texto en <strong>negrita</strong>,
                                        use asteriscos: <code>*Hola*</code>
                                    </li>
                                    <li>
                                        Para texto en <em>cursiva</em>, use
                                        guiones bajos: <code>_Hola_</code>
                                    </li>
                                    <li>
                                        Para texto <s>tachado</s>, use
                                        virgulillas: <code>~Hola~</code>
                                    </li>
                                    <li>
                                        Para <code>monoespaciado</code>, use
                                        tres acentos invertidos:{" "}
                                        <code>```Hola```</code>
                                    </li>
                                </ul>
                            </div>
                            <button
                                onClick={() => setArchivoSeleccionado(null)}
                                className="mt-4 bg-blue-500 text-white px-4 py-2 rounded hover:scale-105"
                            >
                                Guardar
                            </button>
                        </motion.div>
                    )}

                    {imagenSaveSeleccionada !== null && (
                        // Vista de imagen seleccionada con textarea
                        <motion.div
                            initial={{ scale: 0.5, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            exit={{ scale: 0.5, opacity: 0 }}
                            className="w-full flex flex-col items-center gap-4"
                        >
                            <img
                                src={`${process.env.REACT_APP_PROXY}/plantillas_whatsapp/getImagen/${imagenSaveSeleccionada.imagen}`}
                                alt="Imagen seleccionada"
                                className="w-auto h-[300px] rounded-xl border"
                            />
                            <textarea
                                className="w-5/6 max-w-xl p-2 border rounded-md mt-3"
                                placeholder="Escribe una descripción..."
                                value={imagenSaveSeleccionada?.caption}
                                rows={5}
                                onChange={(e) => {
                                    setImagenSaveSeleccionada({
                                        ...imagenSaveSeleccionada,
                                        caption: e.target.value,
                                    });
                                }}
                            />

                            <div className="text-sm text-gray-500 mt-2">
                                <p className="font-semibold">
                                    Instrucciones para dar formato en WhatsApp:
                                </p>
                                <ul className="list-disc ml-4 mt-1">
                                    <li>
                                        Para texto en <strong>negrita</strong>,
                                        use asteriscos: <code>*Hola*</code>
                                    </li>
                                    <li>
                                        Para texto en <em>cursiva</em>, use
                                        guiones bajos: <code>_Hola_</code>
                                    </li>
                                    <li>
                                        Para texto <s>tachado</s>, use
                                        virgulillas: <code>~Hola~</code>
                                    </li>
                                    <li>
                                        Para <code>monoespaciado</code>, use
                                        tres acentos invertidos:{" "}
                                        <code>```Hola```</code>
                                    </li>
                                </ul>
                            </div>
                            <button
                                onClick={() =>
                                    handleSaveImage(imagenSaveSeleccionada)
                                }
                                className="mt-4 bg-blue-500 text-white px-4 py-2 rounded hover:scale-105"
                            >
                                Guardar
                            </button>
                        </motion.div>
                    )}

                    {archivoSaveSeleccionado !== null && (
                        // Vista de imagen seleccionada con textarea
                        <motion.div
                            initial={{ scale: 0.5, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            exit={{ scale: 0.5, opacity: 0 }}
                            className="w-full flex flex-col items-center gap-4 mt-5"
                        >
                            <div className="text-lg px-2 py-1 bg-gray-200 rounded-md">
                                <strong>Nombre:</strong>{" "}
                                {archivoSaveSeleccionado.archivo}
                            </div>
                            <textarea
                                className="w-5/6 max-w-xl p-2 border rounded-md mt-3"
                                placeholder="Escribe una descripción..."
                                value={archivoSaveSeleccionado.caption}
                                rows={5}
                                onChange={(e) => {
                                    setArchivoSaveSeleccionado({
                                        ...archivoSaveSeleccionado,
                                        caption: e.target.value,
                                    });
                                }}
                            />

                            <div className="text-sm text-gray-500 mt-2">
                                <p className="font-semibold">
                                    Instrucciones para dar formato en WhatsApp:
                                </p>
                                <ul className="list-disc ml-4 mt-1">
                                    <li>
                                        Para texto en <strong>negrita</strong>,
                                        use asteriscos: <code>*Hola*</code>
                                    </li>
                                    <li>
                                        Para texto en <em>cursiva</em>, use
                                        guiones bajos: <code>_Hola_</code>
                                    </li>
                                    <li>
                                        Para texto <s>tachado</s>, use
                                        virgulillas: <code>~Hola~</code>
                                    </li>
                                    <li>
                                        Para <code>monoespaciado</code>, use
                                        tres acentos invertidos:{" "}
                                        <code>```Hola```</code>
                                    </li>
                                </ul>
                            </div>
                            <button
                                onClick={() =>
                                    handleSaveArchivo(archivoSaveSeleccionado)
                                }
                                className="mt-4 bg-blue-500 text-white px-4 py-2 rounded hover:scale-105"
                            >
                                Guardar
                            </button>
                        </motion.div>
                    )}
                </div>
            </ResponsiveModalAbsolute>
        </div>
    );
};

export default ModalPlantillaEdit;
